import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Joi from 'joi';
import Fa from 'react-fontawesome';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { FormGroup, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import UserSelector from '../../../../components/user-selector';

import { updateSalesManager } from '../../../Auth/AuthActions';
import { fetchOrganizationUsers } from '../../../Setup/SetupActions';

// Import Selectors
import { getUser, getUserCurrentOrganization } from '../../../Auth/AuthReducer';

/*
function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
*/

class SalesManager extends Component {
  constructor() {
    super();
    this.state = {
      value: '',
      selectedSuggestion: null,
      loading: false,
      loadingValues: false,
    };
    this.renderField = this.renderField.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUserSelected = this.handleUserSelected.bind(this);
  }

  componentDidMount1() {
    const { salesManager, orgId } = this.props;

    const p = new Promise((resolve, reject) => {
      this.props.dispatch(fetchOrganizationUsers(orgId, { q: salesManager, license: true }))
      .then((users) => {
        resolve(users.users.items);
      },
      (e) => {
        reject(e);
      })
    })

    p.then((userArr) => {
      if(userArr) {
        const user = userArr[0];
        this.setState({ value: `${user.first_name} ${user.last_name}` });
      }
    })
  }


  handleUserSelected(userId) {
    this.props.change('sales_manager', userId || null);
  }

  handleSubmit(data) {
     return this.props.dispatch(updateSalesManager(data))
       .then(
         () => {},
         (errors) => {
           let e = errors;
           if (errors.data) {
             e = errors.data;
           }
           throw new SubmissionError(e);
         },
       );
  }

  renderField({
    label,
    className,
    meta: { touched, error },
    submitBtn,
  }) {
    const { salesManager } = this.props;
    const { value } = this.state;

    const validationState = touched && error ? 'error' : null;

    return (
      <FormGroup className={className} validationState={validationState}>
        <ControlLabel>{label}</ControlLabel>
        <div className='row'>
          <div className='col-xs-8 col-sm-9'>
            <UserSelector
              onSelect={this.handleUserSelected}
              query={{ license: true }}
              label={'My Sales Manager:'}
              defaultValue={value}
              userId={salesManager}
              isManager
            />
            {error && touched && <HelpBlock>{error}</HelpBlock>}
          </div>
          <div className='col-xs-4 col-sm-3 text-right'>{submitBtn}</div>
        </div>
      </FormGroup>
    );
  }

  render() {
       const { handleSubmit, valid, submitting } = this.props;
       const submitBtn = (
          <Button type="submit" disabled={(!valid || submitting)}>
            {!submitting && <span>Update</span>}
            {submitting && <span><Fa name="spinner" spin /> Updating</span>}
          </Button>
        );

        return (
          <div>
          <form onSubmit={handleSubmit(this.handleSubmit)}>
            <Field
              name="sales_manager"
              label="My Sales Manager:"
              component={this.renderField}
              submitBtn={submitBtn}
            />
          </form>
        </div>
        )
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const user = getUser(state);
  const salesManager = user ? user.sales_manager : null;
  const initialValues = { sales_manager: salesManager };
  const organization = getUserCurrentOrganization(state);
  const orgId = organization._id;
  return {
    initialValues,
    salesManager,
    orgId
  };
}

SalesManager.propTypes = {
  dispatch: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({}),
  salesManager: PropTypes.string,
  orgId: PropTypes.string,
  initialize: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  change: PropTypes.func.isRequired,
};

SalesManager.defaultProps = {
  salesManager: null,
  initialValues: {},
  orgId: null,
};

SalesManager.contextType = {};

const validate = (values) => {
  // Legacy constraints for reference:
  // const constraints = {
  //   sales_manager: {
  //     type: 'string',
  //     presence: { allowEmpty: false },
  //   },
  // };

  const schema = Joi.object({
    sales_manager: Joi.string().required().messages({
      'string.base': 'Sales manager must be a string',
      'string.empty': 'Sales manager is required',
      'any.required': 'Sales manager is required',
    }),
  }).unknown(true);

  const { error } = schema.validate(values, { abortEarly: false });
  if (!error) return {};
  
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};

const SalesManagerForm = reduxForm({
  form: 'userSalesManagerForm',
  validate,
})(SalesManager);

export default connect(mapStateToProps)(SalesManagerForm);
